
export default {
  name: 'MegastudioTariffsComparisonTableOneTimeTable',
  data() {
    return {
      anonsTable: {
        id: 1,
        header: [
          {
            title: 'Разовые услуги',
            description: null,
          },
          {
            title: 'Количество',
            description: null,
          },
          {
            title: 'Стоимость',
            description: null,
          },
        ],
        options: [
          {
            id: 1,
            header: {
              img: '/img/megastudio/products/socialAdvertisement.webp',
              title: 'Реклама в соцсетях Мегасреды',
              info: '"Публикация находится в топе (последней) 1 час 30 минут и никогда не удаляется.<br /> 125 000 подписчиков',
              status: null,
            },
            status: ['1 пост', '25 000'],
            isVisible: false,
          },
          {
            id: 2,
            header: {
              img: '/img/megastudio/products/articleAnonceSocial.webp',
              title: 'Статьи на сайте с анонсом в соцсетях',
              info: 'Размещаются от аккунта «Мегасреда для бухгалтера» с анонсированием во всех соцсетях.<br />125 000 подписчиков.<br />Публикуется с пометкой «Партнёрский»',
              status: null,
            },
            status: ['1 пост', '35 000'],
            isVisible: false,
          },
          {
            id: 3,
            header: {
              img: '/img/megastudio/products/serviceReview.webp',
              title: 'Обзор вашего сервиса',
              info: 'Подробно и информативно рассказываем о вашем сервисе в виде обзора, а затем с лаконичной и ёмкой подводкой публикуем ссылки в наших соцсетях.',
              status: null,
            },
            status: ['1 обзор', '50 000'],
            isVisible: false,
          },
          {
            id: 4,
            header: {
              img: '/img/megastudio/products/pressRelease.webp',
              title: 'Размещение Пресс-релиза',
              info: 'Размещение материала в канале «Пресс-релизы», с пометкой «Партнёрский»',
              status: null,
            },
            status: ['1 релиз', '10 000'],
            isVisible: false,
          },
        ],
      },
    }
  },
  methods: {
    toggleVisibleDescription({ status, optionId }) {
      const option = this.anonsTable.options.find(
        (option) => option.id === optionId
      )
      option.isVisible = status
    },
  },
}
